module.exports = __webpack_public_path__ + "img/16.85895e11.jpg";